import { Enums } from "./enums";
import { SignalrGroup } from "../model/signlar-message/signalr-group";

export class SignalrHelper {
  private static _signalrGroups: SignalrGroup[] = [];
  private static get SignalrGroups(): SignalrGroup[] {
    if (this._signalrGroups.length == 0) {
      this._signalrGroups.push(new SignalrGroup(Enums.BaseRole.User, "User_"));
      this._signalrGroups.push(
        new SignalrGroup(Enums.BaseRole.Billing, "Billing_"),
      );
      this._signalrGroups.push(
        new SignalrGroup(Enums.BaseRole.Asset, "Asset_"),
      );
      this._signalrGroups.push(
        new SignalrGroup(Enums.BaseRole.Alert, "Alert_"),
      );
      this._signalrGroups.push(
        new SignalrGroup(Enums.BaseRole.Settings, "Settings_"),
      );

      this._signalrGroups.push(
        new SignalrGroup(Enums.BaseRole.BillingReadOnly, "Billing_"),
      );
      this._signalrGroups.push(
        new SignalrGroup(Enums.BaseRole.TicketReadOnly, "Ticket_"),
      );

      this._signalrGroups.push(
        new SignalrGroup(Enums.BaseRole.Calendar, "Calendar_"),
      );
      this._signalrGroups.push(new SignalrGroup(Enums.BaseRole.Crm, "Crm_"));
      this._signalrGroups.push(
        new SignalrGroup(Enums.BaseRole.Ticket, "Ticket_"),
      );

      this._signalrGroups.push(
        new SignalrGroup(Enums.BaseRole.AssetReadOnly, "Asset_"),
      );
    }
    return this._signalrGroups;
  }

  static GetSignalrGroupByRole(
    baseRoleId: number,
    serviceProviderId: number,
  ): string {
    const group = this.SignalrGroups.find((a) => a.baseRoleId == baseRoleId);
    return group ? group.groupName + serviceProviderId : "";
  }
}
